<app-topnav></app-topnav>
<div id="loadconent" style="background-color:#000">
    <main class="inner-content">
        <div class="container-fluid">
            <div class="row">

                <div class="col-md-2 px-sm-1"></div>

                <div class="col-md-7 col-12 p-3" style="color:#F5B942">
                    <h1 style="border-bottom:solid 1px;font-size: 2em;">About Mango777 - Online Betting Site</h1>

                    <p align="justify"><strong>How do I register an account? </strong><br>
                        Click 'Sign Up' on the <a href="//mango777.com/" target="_blank">Mango777</a>, and complete the
                        online form. It’s really important that you enter your correct details, especially your mobile
                        number <a href="#" data-toggle="modal" data-target="#RegModal" id="RegModalBtn">Register</a>
                        your account now.</p>
                    <p align="justify"><strong>How do I deposit?</strong> <br>
                        Once you have registered, choose any payment method including UPI, Indian Debit Cards, Paytm,
                        PhonePay The amount will be credited to your balance immediately after deposit <a
                            href="https://web.whatsapp.com/send?phone=447862777777" target="_blank">customer care</a>
                    </p>

                    <p align="justify"><strong>Which are the games I can play on Mango777?</strong> <br>
                        You can bet on any live sports. There in one single wallet. Once you deposit amount, you can
                        choose from any live casino, sports betting or slots games. We have curated selection of Indian
                        Casino Games like Andar Bahar, 20-20 Cricket, Bollywood Casino, Teen Patti, and much more</p>

                    <p align="justify"><strong>How to withdraw?</strong><br>
                        Withdrawal on Mango777 is very easy. Just click on Withdraw and fill in the details, your
                        withdrawal will be processed immediately. You can also use our Whatsapp Customer Support to
                        generate Withdrawal request. Withdrawal is as easy as playing on Mango777.</p>


                    <p align="justify"><strong>Navigating the Mango777 Website</strong><br>
                        Finding your way around at Mango777 is easy. Whether on a mobile device or desktop, you can
                        navigate to any part of the website via the menu bar at the top of your screen. On Mango777, all
                        sports are listed in the top navigation bar of the screen, with key events highlighted in the
                        ‘Quick Links’ section, or ‘Highlights’ area on the home page. All ‘Live’ or ‘In Play’ events are
                        indicated by the ‘Live’ symbol, meaning you can bet on the action as it unfolds. Use any of our
                        side navigation links or top navigation links to choose your favourite sports for betting or
                        your favourite live casino games</p>

                    <p align="justify"><strong>How to contact customer support</strong><br>
                        We at Mango777 Casino are proud for our live customer support. If you need any help
                        understanding on how to play on Mango777 or have any query regarding our services kindly contact
                        us on our Whatsapp <a href="https://web.whatsapp.com/send?phone=447862777777"
                            target="_blank">Customer Care</a></p>






                </div>

                <div class="col-md-3 px-1 d-none d-sm-block" id="da"></div>
            </div>
        </div>
    </main>
</div>